module.exports = __webpack_public_path__ + "static/media/bg3.15dd67fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/bg3.png
// module id = 983
// module chunks = 0